import React, { useState, useEffect } from "react";
import ModificaProdottiNEW from "./ModificaProdottiNEW";
import DBperCreaProd from "./creaProdotto/DBperCreaProd";
import apiUrl from "../Apiurl";

function UIProdottoDBCrea(props) {
  const product = props.product;
  const setProductFunction = props.setProductFunction;
  const utente = props.utente;
  const tradPermessa = props.tradPermessa;
  const listaNomiProdotto = props.listaNomiProdotto;

  const [brandSelezionato, setBrandSelezionato] = useState(
    "Ultimi articoli creati"
  );
  const [listaBrandDaPubbl, setListaBrandDaPubbl] = useState([]);
  const [listaProdottiBrand, setListaProdottiBrand] = useState([]);
  const [pubblicaTestiOImmagini, setPubblicaTestiOImmagini] = useState(0);
  const [revisionaProdottiImportati, setRevisionaProdottiImportati] =
    useState(false);

  useEffect(() => {
    //copiare anche qui la stessa cosa che fa la funz da tradurre o non far visualizzare niente
    /* if (brandSelezionato === "Ultimi articoli creati") { */
    if (!revisionaProdottiImportati) {
      fetch(apiUrl + "/prodotti/show/all/lastNC/1000")
        .then((resp) => resp.json())
        .then((data) => setListaProdottiBrand(data));
    }

    if (revisionaProdottiImportati) {
      fetch(apiUrl + "/prodotti/show/getImportedProducts")
        .then((resp) => resp.json())
        .then((data) => setListaProdottiBrand(data));
    }

    /* } */
  }, [revisionaProdottiImportati]);

  return (
    <div className="center">
      <div className="cf">
        {/* <h1>scegli prod o crea nuovo: [input show or create]</h1> */}
        <div className="fl w-100 w-100-ns">
          {product.codiceVS === "NO DATA" && (
            <div className="">
              <DBperCreaProd
                product={product}
                setProductFunction={setProductFunction}
                utente={utente}
                tradPermessa={tradPermessa}
                brandSelezionato={brandSelezionato}
                setBrandSelezionato={setBrandSelezionato}
                listaBrandDaPubbl={listaBrandDaPubbl}
                setListaBrandDaPubbl={setListaBrandDaPubbl}
                listaProdottiBrand={listaProdottiBrand}
                setListaProdottiBrand={setListaProdottiBrand}
                pubblicaTestiOImmagini={pubblicaTestiOImmagini}
                setPubblicaTestiOImmagini={setPubblicaTestiOImmagini}
                revisionaProdottiImportati={revisionaProdottiImportati}
                setRevisionaProdottiImportati={setRevisionaProdottiImportati}
              />
            </div>
          )}
        </div>
        <div className="fl w-100 w-100-ns">
          <div className="">
            {product.codiceVS !== "NO DATA" && (
              <ModificaProdottiNEW
                prodotto={product}
                setProductFunction={setProductFunction}
                utente={utente}
                listaNomiProdotto={listaNomiProdotto}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UIProdottoDBCrea;
